import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Button } from '@/components/ui/Button';
import { Card } from '@/components/ui/Card';

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[ErrorBoundary]', error, info);
  }

  render(): ReactNode {
    if (this.state.error) {
      return (
        <div className="flex min-h-[60vh] items-center justify-center px-6">
          <Card className="w-full max-w-lg p-6">
            <h2 className="mb-1 text-base font-semibold text-text-primary">Something broke</h2>
            <p className="mb-4 text-sm text-text-muted">
              {this.state.error.message || 'Unknown error'}
            </p>
            <div className="flex gap-2">
              <Button onClick={() => this.setState({ error: null })}>Try again</Button>
              <Button variant="secondary" onClick={() => window.location.reload()}>
                Reload page
              </Button>
            </div>
          </Card>
        </div>
      );
    }
    return this.props.children;
  }
}
